import { useMemo } from "react";
import { useAuth } from "@/hooks/useAuth";
import { finalizeAppAccess, type AppAccessKey, type AppAccessMap } from "@/lib/appAccess";

export function useAppAccess() {
  const { user } = useAuth();
  const isAdmin = (user?.role ?? "").toLowerCase() === "admin";
  const isMaster = user?.isMaster === true || (user?.username ?? "").trim().toLowerCase() === "master";
  const hasFullAccess = isAdmin || isMaster || user?.siengeFullAccess === true;

  const appAccess = useMemo((): AppAccessMap | null | undefined => {
    if (!user?.appAccess) return user?.appAccess;
    return finalizeAppAccess(user.appAccess);
  }, [user?.appAccess]);

  const can = (key: AppAccessKey): boolean => {
    if (hasFullAccess) return true;
    /* Sessão em cache de build antigo (sem `appAccess`): comportamento legado até /auth/me atualizar. */
    if (user && user.appAccess == null) return true;
    return appAccess?.[key] === true;
  };

  return { can, isAdmin, isMaster, hasFullAccess, appAccess, user };
}
